<template>
  <div>
    <span class="green-spot" v-if="count > 0">
      {{ count }}
    </span>
    <span v-else>
      {{ count }}
    </span>
  </div>
</template>

<script>
export default {
  name: "Chip",
  props: {
    count: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.green-spot {
  color: rgb(255, 255, 255);
  border-radius: 50%;
  background-color: rgb(57, 184, 9);
  padding: 4px;
  margin-left: -10px;
  display: inline-block;
  width: 26px;
  text-align: center;
}
</style>
